<template>
  <ActionDropdown>
      <button
          v-if="coachBill.status === 'approved'"
          class="dropdown-item"
          @click.prevent="createBill(coachBill.id)">
        Rechnung erstellen
      </button>
      <button
          v-else-if="coachBill.status === 'rejected' || coachBill.status === 'answered'"
          class="dropdown-item"
          @click.prevent="showRejectionReason(coachBill.id)">
        Suchen Sie nach einem Grund für die Ablehnung
      </button>
      <button
          v-else-if="coachBill.status === 'pending'"
          class="dropdown-item"
          @click.prevent="rejectBill(coachBill.id)">
        Abgelehnt
      </button>

      <button
          v-if="coachBill.coachingType === 'private_coaching'"
          class="dropdown-item"
          @click.prevent="printPrivateCoaching">
        Drucken
      </button>
      <button
          v-if="
          coachBill.coachingType === 'group_coaching' &&
          coachBill.billingType === 'pauschalbetrag'"
          class="dropdown-item"
          @click.prevent="printGroupCoachingPauschal">
        Drucken
      </button>
      <button
          v-else-if="
          coachBill.coachingType === 'group_coaching' &&
          coachBill.billingType !== 'pauschalbetrag'"
          class="dropdown-item"
          @click.prevent="printGroupCoachingHourly">
        Drucken
      </button>
      <button
          v-if="coachBill.coachingType === 'assisted_living_coaching'"
          class="dropdown-item"
          @click.prevent="printAssistedLivingCoaching">
        Drucken
      </button>
      <button
          v-if="coachBill.coachingType === 'case_management_coaching'"
          class="dropdown-item"
          @click.prevent="printCaseManagementCoaching">
        Drucken
      </button>
  </ActionDropdown>
</template>

<script setup>
import ActionDropdown from '@/components/ActionDropdown.vue';
import { CloseToast } from '@/components/VueToast';
import { downloadFile } from '@/shared/functions';
import { defineEmits, defineProps } from 'vue';

const emit  = defineEmits([ 'rejectBill', 'showReasonForRejection', 'createBill' ]);
const props = defineProps({
  coachBill: {
    type: Object,
    required: true,
  },
});

const createBill = (id) => {
  CloseToast();
  emit('createBill', id);
};

const showRejectionReason = (id) => {
  CloseToast();
 emit('showReasonForRejection', id)
};

const rejectBill = (id) => {
  CloseToast();
  emit('rejectBill', id);
};

const printPrivateCoaching = () => {
  downloadFile(
      `/coach-billing/private-coaching/print-bill/${props.coachBill.id}`,
      undefined,
  );
};

const printGroupCoachingHourly = () => {
  downloadFile(
      `/coach-billing/group-coaching/hourly-wages-bill-print/${props.coachBill.id}`,
      undefined,
  );
};

const printGroupCoachingPauschal = () => {
  downloadFile(
      `/coach-billing/group-coaching/pauschal-print/${props.coachBill.id}`,
      undefined,
  );
};

const printAssistedLivingCoaching = () => {
  downloadFile(
      `/coach-billing/assisted-living-coaching/print-bill/${props.coachBill.id}`,
      undefined,
  );
};

const printCaseManagementCoaching = () => {
  downloadFile(
      `/coach-billing/case-management-coaching/print-bill/${props.coachBill.id}`,
      undefined,
  );
};
</script>